import React from 'react'
import Navbar from '../components/Navbar'
import Form from '../components/BuyForm'
import BuyForm from '../components/BuyForm'

const Buy = () => {
  return (
    <div>
        <Navbar/>
        <BuyForm/>
    </div>
  )
}

export default Buy